import React from 'react';
import { BrandAwarenessUsageOpportunitiesStyles } from './styles';
import { useAppSelector } from '../../../state/hooks';
import getTranslationsByLangOrEng from '../../../utils/getTranslationsByLangOrLang';

export const BrandAwarenessUsageOpportunities = () => {
  const { interfaceLanguage } = useAppSelector((state) => state.languages);

  return (
    <BrandAwarenessUsageOpportunitiesStyles>
      <div className="container">
        <h5>
          {getTranslationsByLangOrEng(interfaceLanguage, 'usage_attitude_27')}
        </h5>
        <div className="content">
          <h2>
            {getTranslationsByLangOrEng(interfaceLanguage, 'brand_awareness_10')}
          </h2>
          <div className="opportunities">
            <div className="opportunities__list">
              <h3>{getTranslationsByLangOrEng(interfaceLanguage, 'brand_awareness_11')}</h3>
              <ul>
                <li
                  dangerouslySetInnerHTML={{
                    __html: getTranslationsByLangOrEng(
                      interfaceLanguage,
                      'brand_awareness_13',
                    ),
                  }}
                />
                <li
                  dangerouslySetInnerHTML={{
                    __html: getTranslationsByLangOrEng(
                      interfaceLanguage,
                      'brand_awareness_14',
                    ),
                  }}
                />
                <li
                  dangerouslySetInnerHTML={{
                    __html: getTranslationsByLangOrEng(
                      interfaceLanguage,
                      'brand_awareness_15',
                    ),
                  }}
                />
                <li
                  dangerouslySetInnerHTML={{
                    __html: getTranslationsByLangOrEng(
                      interfaceLanguage,
                      'brand_awareness_16',
                    ),
                  }}
                />
              </ul>
            </div>
            <div className="opportunities__list">
              <h3>{getTranslationsByLangOrEng(interfaceLanguage, 'brand_awareness_12')}</h3>
              <ul>
                <li
                  dangerouslySetInnerHTML={{
                    __html: getTranslationsByLangOrEng(
                      interfaceLanguage,
                      'brand_awareness_17',
                    ),
                  }}
                />
                <li
                  dangerouslySetInnerHTML={{
                    __html: getTranslationsByLangOrEng(
                      interfaceLanguage,
                      'brand_awareness_18',
                    ),
                  }}
                />
                <li
                  dangerouslySetInnerHTML={{
                    __html: getTranslationsByLangOrEng(
                      interfaceLanguage,
                      'brand_awareness_19',
                    ),
                  }}
                />
                <li
                  dangerouslySetInnerHTML={{
                    __html: getTranslationsByLangOrEng(
                      interfaceLanguage,
                      'brand_awareness_20',
                    ),
                  }}
                />
              </ul>
            </div>
          </div>
        </div>
      </div>
    </BrandAwarenessUsageOpportunitiesStyles>
  );
};
